import Icon from '@atoms/Icon/Icon';
import { useWishlistStore } from '@state/WishlistStore';
import { motion } from 'motion/react';
import { useEffect, useMemo } from 'react';
interface Props {
  readonly link: string;
}

const HeaderLikeIcon = ({ link }: Props) => {
  const { wishlists, fetchWishlists } = useWishlistStore();

  useEffect(() => {
    fetchWishlists();
  }, [fetchWishlists]);

  // Get total amount of likes to replicate existing functionality
  const likedItemCount = useMemo(() => {
    return wishlists.reduce(
      (count, wishlist) => count + wishlist.likes.length,
      0,
    );
  }, [wishlists]);

  return (
    <a href={link} className="tw-relative" aria-label="wishlist">
      <div>
        <Icon name="heart" className="tw-text-2xl" size="1.5rem" />
        {!!likedItemCount && (
          <motion.span
            key={likedItemCount}
            animate={{ y: [0, -2, 0] }}
            className="tw-absolute -tw-right-[7px] -tw-top-[4px] tw-flex tw-h-xs tw-w-xs tw-items-center tw-justify-center tw-rounded-full tw-bg-[#ff4a49] tw-text-[10px] tw-text-white"
          >
            {likedItemCount >= 9 ? '9+' : likedItemCount}
          </motion.span>
        )}
      </div>
    </a>
  );
};

export default HeaderLikeIcon;
